export default function Logo() {
  return (
    <h1 className="text-5xl font-monoton uppercase h-36 text-center bg-[#ffa23c] w-full pt-10">
      🌴 far away 💼
    </h1>
  );
}
